/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardExtra } from '../../../Shared/Card'
import { CardTitle } from '../../../Shared/CardTitle'
import { Icon, Image } from 'semantic-ui-react'
import { Link } from 'react-router-dom-v5-compat'
import { useState } from 'react'
import { useDeviceMediaQuery } from '../../../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'

const data = {
    platforms: [
        {
            module: 'ubereats',
            markups: {
                main: '22',
                secondary: [],
            },
        },
        {
            module: 'deliveroo',
            markups: {
                main: '20',
                secondary: ['18.03', '26'],
            },
        },
        {
            module: 'shopify',
            markups: {
                main: '15',
                secondary: ['18.03', '26'],
            },
        },
        {
            module: 'justeat',
            markups: {
                main: '15',
                secondary: ['18.03', '26'],
            },
        },
    ],
}

const getRandomData = () => {
    return {
        platforms: data.platforms.slice(0, Math.floor(Math.random() * data.platforms.length) + 1),
    }
}

const MarkupsCard = () => {
    const [t] = useTranslation()
    const { isMobile } = useDeviceMediaQuery()
    const [randomData, setRandomData] = useState(data)

    const getMinMaxMarkups = (markups) => {
        if (markups.secondary.length === 0) {
            return [markups.main, markups.main]
        }

        const allMarkups = [markups.main, ...markups.secondary].map(markup => parseFloat(markup))
        const minMarkup = Math.min(...allMarkups)
        const maxMarkup = Math.max(...allMarkups)

        return [minMarkup, maxMarkup]
    }

    const computePriceIncrease = (markup) => {
        const increaseValue = Math.fround((100 * markup) / (100 - markup))
        return `${increaseValue < 0 ? '-' : '+'}${increaseValue.toFixed(2)}`
    }

    const moreThan3Items = randomData.platforms.length > 3

    return (
      <Card
        css={css`
            border-top: 2px solid grey;

            .card-content {
                width: ${isMobile ? '340px' : '360px'};
                min-height: 340px;
            }
        `}
      >
          <CardContent
            css={css`
                display: flex;
                flex-direction: column;
                height: 100%;
            `}
          >
              <div
                css={css`
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 1rem;
                `}
              >
                  <CardTitle
                    css={css`
                        margin-top: .25rem;
                    `}
                    title={'Markups actifs'}
                  />
                  <Icon
                    css={css`
                        cursor: pointer;
                    `}
                    name="retweet" onClick={() => {
                      const newData = getRandomData()
                      setRandomData(newData)
                  }}/>
              </div>


              <div
                css={css`
                    padding: 12px;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 1rem;
                    justify-content: ${moreThan3Items ? 'space-between' : 'space-evenly'};
                    flex: 1;
                    height: 100%;
                `}
              >
                  {randomData.platforms.map((platform) => {
                      const [minMarkup, maxMarkup] = getMinMaxMarkups(platform.markups)
                      const isSameValue = minMarkup === maxMarkup

                      return (
                        <div key={platform.module}
                             css={css`
                                 display: flex;
                                 justify-content: flex-start;
                                 align-items: center;
                                 gap: .5rem;
                             `}
                        >
                            <Image
                              src={`/img/platforms/${platform.module}.jpg`}
                              size={moreThan3Items ?
                                'mini' :
                                'tiny'
                              }
                            />

                            <div
                              css={css`
                                  display: flex;
                                  flex-direction: column;
                              `}
                            >
                                <strong
                                  css={css`
                                      font-size: ${moreThan3Items ? '1.3em' : '1.5em'};
                                  `}
                                >
                                    {isSameValue ?
                                      `${minMarkup}% ` :
                                      `${minMarkup}% - ${maxMarkup}%`
                                    }
                                </strong>
                                <i>
                                    Soit {isSameValue ?
                                  <strong>{computePriceIncrease(minMarkup)}%</strong> :
                                  <>
                                      entre <strong>{computePriceIncrease(minMarkup)}%</strong> et <strong>{computePriceIncrease(maxMarkup)}%</strong>
                                  </>
                                } du prix catalogue
                                </i>
                            </div>
                        </div>
                      )
                  })}
              </div>
          </CardContent>

          <CardExtra>
              <Link
                to={{
                    pathname: '/categories/publications',
                }}>
                  {t('category_set.manage_link')}
                  <Icon name="arrow right"/>
              </Link>
          </CardExtra>
      </Card>
    )
}

export { MarkupsCard }
